import { render, staticRenderFns } from "./LiveGoodsManager.vue?vue&type=template&id=6d2a527d&scoped=true"
import script from "./LiveGoodsManager.vue?vue&type=script&lang=js"
export * from "./LiveGoodsManager.vue?vue&type=script&lang=js"
import style0 from "./LiveGoodsManager.vue?vue&type=style&index=0&id=6d2a527d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a527d",
  null
  
)

export default component.exports